import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import '../pages/css/Home.css';
import '../pages/css/ProductPageUpdated.css';
import banner from '../images/hrias-banner.jpg';
import dashboard from '../images/dash.gif';
import servicebg from '../images/testimonial-bg.png';
import { FaLaptopCode, FaBrain, FaGreaterThan, FaLessThan } from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';
import product1 from '../images/product1.gif';
import product2 from '../images/product2.gif';
import product3 from '../images/product3.gif';
import product4 from '../images/product4.gif';
import product5 from '../images/product5.gif';
import product6 from '../images/product6.gif';
import marketing1 from '../images/marketing1.svg';
import marketing2 from '../images/marketing2.svg';
import marketing3 from '../images/marketing3.svg';
import marketing4 from '../images/marketing4.svg';
import ct1 from '../images/ct1.jpg';
import ct2 from '../images/ct5.jpg';
import ct3 from '../images/ct2.jpg';
import ct4 from '../images/ct7.jpg';
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function HriasPricing() {
const navigate = useNavigate();

  return (
    <>


        <section className="container my-5 pricing-section">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Choose <span style={{ color: '#fd7e14' }}>Your</span> Plan <span style={{ color: '#fd7e14' }}>- B2B</span>
          </h2>
          <p className="text-muted">Find the right package that fits your business needs.</p>
        </div>

        <div className="row justify-content-center">
          {/* Box 1 */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box">
              <h4 className="package-name">Starter Plan</h4>

              <button
                className="btn btn-primary mb-3"
                onClick={() => navigate("/contact-us-hrias")}
              >
                Contact Sales
              </button>

              <ul
                className="feature-list"
                style={{ fontFamily: "Poppins, sans-serif", lineHeight: "1.8" }}
              >
                <li>
                  <strong>Data & Lead Generation</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    50 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Deliverability — 2 sending emails, 1 LinkedIn account, 1 WhatsApp number
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Automated Outreach & Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups via email
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Multi-channel Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Auto LinkedIn visits, invites, and messages
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>AI-powered Personalization</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Custom AI-generated templates for all channels
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Lead Sync Importer</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads (up to 50 contacts)
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Integrated CRM</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Export data as downloadable PDF or CSV
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Enablement & Support</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>
            </div>
          </div>


          {/* Box 2 (Active / Highlighted) */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box active-box position-relative">
              {/* 🔹 Top Selling Tag */}
              <span className="top-selling-tag">Top Selling</span>

              <h4 className="package-name">Growth Plan</h4>
              <button className="btn btn-light mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <ul
                className="feature-list"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  lineHeight: "1.8",
                  color: "white",
                }}
              >
                <li>
                  <strong>Data & Lead Generation</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Highly targeted 90% verified contact database
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    150 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    1 lead = 1 credit
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Intents & signals targeting with global keyword research analysis
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Deliverability — 4 sending emails, 1 LinkedIn account, 1 WhatsApp number
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Automated Outreach & Unlimited Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Unlimited automated outreach and follow-ups via email
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Smart Mail Thread Sync & Auto-Personalize</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Automatically groups all outgoing and incoming lead emails into a single threaded sequence
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dynamically replaces lead names in email drafts during campaign sends
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Lead Sync Importer</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Import your leads up to 100 contacts
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Multi-channel Follow-ups</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Auto LinkedIn visits, invites, and messages
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    WhatsApp messages with images
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>AI-powered Personalization</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Customized AI-generated templates for all communication channels
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Integrated CRM</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Track Open, Reply, and Click-through rates
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Downloadable reports in PDF or CSV format
                  </li>
                </ul>

                <li className="mt-2">
                  <strong>Enablement & Support</strong>
                </li>
                <ul className="ps-1 list-unstyled">
                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    In-app live support
                  </li>

                  <li>
                    <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                    Dedicated Account Manager
                  </li>
                </ul>
              </ul>

            </div>
          </div>

          {/* Box 3 - Enterprise Plan */}
          <div className="col-md-4 mb-4">
            <div className="pricing-box shadow-sm p-4 rounded h-100" style={{ border: "1px solid #e0e0e0", backgroundColor: "#fff", fontFamily: "Poppins, sans-serif" }}>
              <h4 className="package-name fw-bold text-center mb-3">Enterprise Plan</h4>
              <button className="btn btn-primary d-block mx-auto mb-3" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
              <div>
                <ul className="feature-list" style={{ lineHeight: "1.8" }}>
                  <li><strong>Data & Lead Generation</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Highly targeted 90% verified contact database
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      250 free verified leads per month — emails, company numbers, LinkedIn IDs and whatsapp numbers
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      1 lead = 1 credit
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Deliverability — 8 sending emails, 1 LinkedIn account, 1 WhatsApp number
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Smart Mail Thread Sync & Auto-Personalize</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Groups all lead emails into one thread
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Auto name replacement in campaign sends
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Lead Sync Importer</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Import up to 200 contacts
                    </li>

                  </ul>

                  <li className="mt-2"><strong>AI-powered Personalization</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      AI templates across all channels
                    </li>

                  </ul>

                  <li className="mt-2"><strong>Integrated CRM</strong></li>
                  <ul className="ps-1 list-unstyled">

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Track Open, Reply & CTR
                    </li>

                    <li>
                      <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                      Export data as PDF/CSV
                    </li>

                  </ul>
                </ul>

              </div>
            </div>
          </div>
        </div>

        {/* Add-ons Box in New Line */}
        <div className="row justify-content-center mt-5">
          <div className="col-md-8">
            <div className="addons-box shadow-sm p-4 rounded text-center" style={{ backgroundColor: "#f0f4ff", border: "1px solid #cfe2ff" }}>
              <h5 className="fw-bold mb-3" style={{ color: "#0d6efd" }}>Add-ons & Extensions</h5>
              <ul className="text-start ps-5" style={{ lineHeight: "1.8" , listStyle: "none" }}>
                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Integration with HubSpot and Salesforce
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Unlimited lead imports
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Built-in calling dialer with call recordings
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Custom feature development within Hrias
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Custom branded image templates for emails
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Access verified phone numbers (1 phone = 5 credits)
                </li>

                <li>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "green",
                      color: "#fff",
                      borderRadius: "50%",
                      marginRight: "10px",
                      fontSize: "14px",
                    }}
                  >
                    ✓
                  </span>
                  Secure cloud storage for campaigns
                </li>
              </ul>


            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default HriasPricing